import { motion } from "framer-motion"
import { LibraryBig, School, GraduationCap } from "lucide-react"
import SolutionImage from "../assets/screenshot.png"

export function Solution() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-gradient-to-tr from-black/10 to-transparent blur-3xl" />
        <div className="absolute -right-24 top-32 h-72 w-72 rounded-full bg-gradient-to-tr from-gray-400/20 to-transparent blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left: Image */}
        {/* Desktop: full phone screenshot */}
        <motion.img
          src={SolutionImage}
          alt="Bookay Lösung"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="hidden lg:block w-full max-w-sm mx-auto aspect-[9/19] object-contain"
        />

        {/* Mobile: cropped version */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="relative lg:hidden w-full aspect-[5/6] max-w-md mx-auto overflow-hidden rounded-3xl shadow-2xl">
          <img src={SolutionImage} alt="Bookay Lösung" className="h-full w-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
        </motion.div>

        {/* Right: Content */}
        <div className="space-y-8">
          <div className="space-y-4">
            <span className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium">
              <School className="h-3.5 w-3.5" /> Lösung
            </span>

            <h2 className="text-4xl font-bold tracking-tight">Ein geschlossener Schulbuchkreislauf</h2>

            <p className="text-gray-600 text-lg">
              Bookay verbindet Schüler innerhalb einer Schule und ermöglicht die strukturierte Weitergabe gebrauchter Schulbücher.
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                icon: LibraryBig,
                title: "Digitale Buchverwaltung",
                text: "Bücher zentral erfassen und organisieren",
              },
              {
                icon: School,
                title: "Schulinterner Marktplatz",
                text: "Austausch innerhalb der eigenen Schule",
              },
              {
                icon: GraduationCap,
                title: "Klare Struktur",
                text: "Bücher erreichen direkt die nächste Jahrgangsstufe",
              },
            ].map((item, i) => (
              <div key={i} className="flex gap-3">
                <item.icon className="h-5 w-5 mt-1" />
                <div>
                  <h3 className="font-semibold">{item.title}</h3>
                  <p className="text-sm text-gray-600">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
